module.exports = __webpack_public_path__ + "img/iw.a4c001f6.png";